// extracted by mini-css-extract-plugin
module.exports = {"noJsWarning":"_39K04Vct6M7t2Kw70P5Qc8"};